import React from 'react';

export function IconVerified({ className }: { className?: string }) {
    return (
        <svg width='12' height='12' viewBox='0 0 12 12' fill='none' className={className} xmlns='http://www.w3.org/2000/svg'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM10.3904 3.31235C10.5629 3.09672 10.528 2.78207 10.3123 2.60957C10.0967 2.43706 9.78207 2.47202 9.60957 2.68766L5.95854 7.25144L3.85355 5.14645C3.65829 4.95119 3.34171 4.95119 3.14645 5.14645C2.95118 5.34171 2.95118 5.65829 3.14645 5.85356L5.64645 8.35356C5.74701 8.45412 5.88565 8.5071 6.02765 8.49924C6.16965 8.49137 6.30159 8.42341 6.39043 8.31235L10.3904 3.31235Z'
                fill='#49A500'
            />
        </svg>
    );
}
